import { JSONLD } from 'lincd-jsonld/utils/JSONLD';
import { createNameSpace } from 'lincd/utils/NameSpace';
import { linkedOntology } from '../package.js';
//import all the exports of this file as one variable called _this (we need this at the end)
import * as _this from './lincd-server.js';
/**
 * Load the data of this ontology into memory, thus adding the properties of the entities of this ontology to the local graph.
 */
export var loadData = async () => {
    if (typeof module !== 'undefined' && typeof exports !== 'undefined') {
        // CommonJS import
        //@ts-ignore
        return import('../data/lincd-server.json').then((data) => JSONLD.parse(data));
    }
    else {
        // ESM import
        //@ts-ignore
        return import('../data/lincd-server.json', {
            with: {
                type: 'json',
            },
        }).then((data) => {
            return JSONLD.parse(data.default);
        });
    }
};
/**
 * The namespace of this ontology, which can be used to create NamedNodes with URI's not listed in this file
 */
export var ns = createNameSpace('http://lincd.org/ont/lincd-server/');
/**
 * The NamedNode of the ontology itself
 */
export var _self = ns('');
//A list of all the entities (Classes & Properties) of this ontology, each exported as a NamedNode
export var LincdServer = ns('LincdServer');
export var BackendFileStore = ns('BackendFileStore');
export var NodeFileStore = ns('NodeFileStore');
export var BackendStore = ns('BackendStore');
export var BackendAPIStore = ns('BackendAPIStore');
export var LincdWebApp = ns('LincdWebApp');
export var ownPackage = ns('ownPackage');
export var maintainsPackage = ns('maintainsPackage');
export var N3FileStore = ns('N3FileStore');
export var LincdAPI = ns('LincdAPI');
export var hasAPI = ns('hasAPI');
//An extra grouping object so all the entities can be accessed from the prefix/name
export const lincdServer = {
    LincdServer,
    BackendFileStore,
    NodeFileStore,
    BackendStore,
    N3FileStore,
    BackendAPIStore,
    LincdWebApp,
    ownPackage,
    maintainsPackage,
    LincdAPI,
    hasAPI,
};
//Registers this ontology to LINCD.JS, so that data loading can be automated amongst other things
linkedOntology(_this, ns, 'lincd-server', loadData, '../data/lincd-server.json');
//# sourceMappingURL=lincd-server.js.map